import { render } from "./Artists.vue?vue&type=template&id=0eb76cfc&scoped=true"
import script from "./Artists.vue?vue&type=script&lang=js"
export * from "./Artists.vue?vue&type=script&lang=js"

import "./Artists.vue?vue&type=style&index=0&id=0eb76cfc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eb76cfc"]])

export default __exports__